import Cookies from 'js-cookie'

const TokenKey = 'unlock_merchant_admin_token'

import { setLocalStorageKeyVal, getLocalStorageVal, removeLocalStorageVal } from '@/utils/helper'

export function getToken() {
  const itemStr = getLocalStorageVal(TokenKey)
  if(!itemStr) return null;

  const item = JSON.parse(itemStr)

  if(item.expire < Date.now()) {
    removeToken();
    return null;
  }

  return item.value
}

export function setToken(token) {
  return setLocalStorageKeyVal(TokenKey, token)
}

export function removeToken() {
  return removeLocalStorageVal(TokenKey)
}
